import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import {
  TextField,
  Autocomplete,
  Typography,
  Stack,
  Tooltip,
} from '@mui/material';
// ----------------------------------------------------------------------

RHFMultiSelect.propTypes = {
  tags: PropTypes.array,
  name: PropTypes.string
};

export default function RHFMultiSelect({ name, tags }) {
  const { control } = useFormContext();

  return (

    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        let placeholder = '';
        const textLabel = field.value?.map(item => item.label)?.join(', ');
        if (field.value.length > 0)
          placeholder = field.value.length > 1 ?
            <> <Typography
              style={{
                maxWidth: 130
              }}
              noWrap
            >
              {textLabel}
            </Typography>
              {field.value.length > 1 && <b style={{ position: 'absolute', right: -4 }}>({field.value.length})</b>}
            </>
            : <Typography
              style={{
                maxWidth: 130
              }}
              noWrap
            >{field.value[0].label}
            </Typography>;

        return <Autocomplete
          {...field}
          value={field.value}
          id="size-small-standard-multi"
          multiple
          onChange={(event, newValue) => field.onChange(newValue)}
          options={tags.map((option) => option)}
          isOptionEqualToValue={(option, value) => option.code === value.code}
          disableCloseOnSelect
          renderOption={(props, option) => (
            <li {...props}>
              {option.label}
            </li>
          )}

          renderInput={(params) => error ? <Tooltip placement="right" title={error.message}>
            <TextField placeholder=""  {...params} error={!!error} />
          </Tooltip> : <TextField placeholder="" {...params} />}
          renderTags={() =>
            <Stack direction="row" sx={{ fontSize: 'small', position: 'relative', paddingLeft: 2, top: 4, width: 260 }} spacing={1}>
              {placeholder}

            </Stack>
          }

        />;
      }



      }
    />
  );
}
